var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronzeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "svg-gobbler (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.913,
    height: 16.122,
    viewBox: "0 0 17.913 16.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pjg3wa12da",
    x1: 1.212,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbb06e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804a00"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M17.866 6.092a.94.94 0 0 0-.82-.615l-5.17-.441L9.832.543a.977.977 0 0 0-1.751 0L6.037 5.037l-5.171.44a.942.942 0 0 0-.819.615.859.859 0 0 0 .278.95l3.908 3.219-1.152 4.767a.867.867 0 0 0 .37.923 1 1 0 0 0 1.046.043l4.46-2.5 4.458 2.5a1 1 0 0 0 1.046-.043.868.868 0 0 0 .37-.923l-1.152-4.767 3.908-3.218a.86.86 0 0 0 .279-.951z",
    style: {
      fill: "url(#pjg3wa12da)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeIcon);
export default __webpack_public_path__ + "static/media/bronze-icon.a9e530258b6a9d0ae7a19fa4e55e1077.svg";
export { ForwardRef as ReactComponent };